export const loadScript = (src: string): Promise<void> =>
    new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`) !== null) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = (): void => resolve();
        script.onerror = (): void => reject(new Error(`Failed to load script: ${src}`));
        document.body.appendChild(script);
    });
